// Template217: Osaka - Cómo llegar desde los aeropuertos (Airports)
// Header, intro, KIX box, ITM box, JR Pass tip, sticker.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template217 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const kixTitle = page?.texts?.[2]?.content;
	const kixBody = page?.texts?.[3]?.content;
	const kixList = page?.texts?.[4]?.content;
	const itmTitle = page?.texts?.[5]?.content;
	const itmBody = page?.texts?.[6]?.content;
	const itmList = page?.texts?.[7]?.content;
	const jrTip = page?.texts?.[8]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerImage = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const boxStyle = {
		backgroundColor: "#d1e6de",
		border: "2px solid #1F4E3D",
		borderRadius: "16px",
		padding: 2,
	};

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: 1,
		color: "#1F4E3D",
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={estiloP}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 2,
					position: "relative",
				}}
			>
				{(kixTitle || kixBody || kixList) && (
					<Box data-block-id="text-3" sx={boxStyle}>
						{kixTitle && (
							<Box component="h3" sx={{ ...estiloH3, marginTop: 0 }}>
								{kixTitle}
							</Box>
						)}
						{kixBody && (
							<Box component="p" sx={{ ...estiloP, marginBottom: 1 }}>
								{kixBody}
							</Box>
						)}
						{kixList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.25, margin: 0 }}
								dangerouslySetInnerHTML={{ __html: kixList }}
							/>
						)}
					</Box>
				)}

				{(itmTitle || itmBody || itmList) && (
					<Box data-block-id="text-4" sx={boxStyle}>
						{itmTitle && (
							<Box component="h3" sx={{ ...estiloH3, marginTop: 0 }}>
								{itmTitle}
							</Box>
						)}
						{itmBody && (
							<Box component="p" sx={{ ...estiloP, marginBottom: 1 }}>
								{itmBody}
							</Box>
						)}
						{itmList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.25, margin: 0 }}
								dangerouslySetInnerHTML={{ __html: itmList }}
							/>
						)}
					</Box>
				)}

				{jrTip && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 13,
							marginTop: 0,
						}}
					>
						{jrTip}
					</Box>
				)}

				{stickerImage && (
					<Box
						component="img"
						src={stickerImage}
						alt=""
						sx={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -50 : -20,
							right: -10,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template217.thumbnail = "/images/template-1.png";
export default Template217;
